import { Component, Input } from '@angular/core';
import { Business } from '../../../services/business.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  @Input() business: Business | null = null;
  currentYear = new Date().getFullYear();

  getSocialMediaLinks(): { platform: string; link: string; icon: string }[] {
    if (!this.business?.social_urls) return [];
    const socials = this.business.social_urls;
    const platforms: { platform: string; key: keyof typeof socials; icon: string }[] = [
      { platform: 'Facebook', key: 'facebook', icon: 'icofont icofont-social-facebook' },
      { platform: 'Instagram', key: 'instagram', icon: 'icofont icofont-social-instagram' },
      { platform: 'Behance', key: 'behance', icon: 'icofont icofont-social-behance' },
      { platform: 'LinkedIn', key: 'linkedin', icon: 'icofont icofont-social-linkedin' },
      { platform: 'TikTok', key: 'tiktok', icon: 'fab fa-tiktok' },
      { platform: 'YouTube', key: 'youtube', icon: 'icofont icofont-social-youtube' },
      { platform: 'X (Twitter)', key: 'twitter', icon: 'icofont icofont-social-twitter' },
      { platform: 'WhatsApp', key: 'whatsapp', icon: 'icofont icofont-social-whatsapp' },
      { platform: 'Google Reviews', key: 'google_reviews', icon: 'fas fa-star' }
    ];
    return platforms
      .filter(p => socials[p.key] && typeof socials[p.key] === 'string')
      .map(p => ({ platform: p.platform, link: socials[p.key] as string, icon: p.icon }));
  }
}